import type {PS, PublicMethodUtils} from '@wix/document-services-types'
import type {ComponentBoundingBox} from '@wix/viewer-manager-interface'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {getter, dataManipulation, immediate} = publicMethodUtils.extensionPublicAPI

    const {deprecate} = publicMethodUtils

    return {
        methods: {
            components: {
                innerElements: {
                    setManifests: immediate('builderComponents.setManifests'),
                    getInnerElementBoundingBoxes: publicMethodUtils.defineGetter(
                        (ps: PS, path: string[]): ComponentBoundingBox[] =>
                            ps.siteAPI.getInnerElementBoundingBoxes(path)
                    ),
                    serializeInnerElementPath: getter('innerElements.serializeInnerElementPath'),
                    style: {
                        get: deprecate(
                            getter('innerElements.getInnerElementStyle'),
                            'use components.innerElements.cssStyle.get instead. This API will be removed by 10/8/26.'
                        ),
                        set: deprecate(
                            dataManipulation('innerElements.setInnerElementStyle'),
                            'use components.innerElements.cssStyle.update instead. This API will be removed by 10/8/26.'
                        ),
                        remove: deprecate(
                            dataManipulation('innerElements.removeInnerElementStyleProperties'),
                            'use components.innerElements.cssStyle.remove instead. This API will be removed by 10/8/26.'
                        )
                    },
                    cssStyle: {
                        get: getter('innerElements.getInnerElementStyle'),
                        update: dataManipulation('innerElements.setInnerElementStyle'),
                        remove: dataManipulation('innerElements.removeInnerElementStyleProperties')
                    },
                    data: {
                        get: getter('innerElements.getInnerElementData'),
                        getTranslationOverrides: getter('innerElements.getInnerElementTranslationOverrides'),
                        set: dataManipulation('innerElements.setInnerElementData'),
                        removeTranslationOverrides: dataManipulation(
                            'innerElements.removeInnerElementTranslationOverrides'
                        ),
                        removeTranslationOverridesForAField: dataManipulation(
                            'innerElements.removeInnerElementTranslationOverridesForAField'
                        )
                    },
                    slots: {
                        populate: getter('innerElements.setInnerElementSlots'),
                        get: getter('innerElements.getInnerElementSlots')
                    },
                    presets: {
                        get: getter('innerElements.getInnerElementPresets'),
                        set: dataManipulation('innerElements.setInnerElementPresets')
                    },
                    remove: dataManipulation('innerElements.removeInnerElement'),
                    restore: dataManipulation('innerElements.restoreInnerElement'),
                    getInnerElementsMetaData: getter('innerElements.getInnerElementsMetadata')
                }
            }
        }
    }
}
